<template>
  <div>
    <BaseModal :config="DirectInvestmentModalLabel" @ResetFields="resetFields" @SaveChanges="saveChanges">
      <div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">       
        <form ref="refDirectInvestmentForm" id="DirectInvestmentForm" action>        
          <div id="pageErrors" class="alert alert-danger"  v-if="pageErrors.length>0">
            <p >
            <b >Please correct the following error(s):</b>
            <ul >
            <li  v-for="error in pageErrors" :key="error">{{ error }}</li>
            </ul>
            </p>
          </div>
          <div
            id="Customerror"
            class="alert alert-danger"
            role="alert"
            v-show="customerrors.length && !errors.items.length"
          >
            <span v-show="customerrors.length" class="alert-danger">
             <b>Please correct the following error(s):</b>
            <ul>
            <li v-for="error in customerrors" :key=error>{{ error }}</li>
            </ul>
            </span>
          </div>

          
 			<div class="form-row">
            <div class="form-group col-md-6">
              <label class="required-label">Investment</label>              
              <div class="input-group mb-3 pl-0">
                <kendo-autocomplete
                  id="SearchInvestment"
                  class="form-control"
                  name="Program"				  
                  v-model="InvestmentAutoCompleteDisplayedValue"
                  :data-source="InvestmentAutoCompleteSource"
                  :data-text-field="'Title'"
                  :filter="'contains'"
                  :placeholder="'Search for Investment'"
                  @select="onInvestmentAutoCompleteSelect"
                  @open="onInvestmentOpen"
                  @close="onInvestmentClose"
                ></kendo-autocomplete>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-search"></i>
                  </span>
                </div>
              </div>
              
            </div>
			<div class="form-group col-md-6">
              <label class="required-label">Partner</label>              
              <div class="input-group mb-3 pl-0">
                <kendo-autocomplete
                  id="SearchPartner"
                  name="Partner"
                  class="form-control"
                  v-model="PartnerAutoCompleteDisplayedValue"
                  :data-source="PartnerAutoCompleteSource"
                  :data-text-field="'FullName'"
                  :filter="'contains'"
                  :placeholder="'Search for Partner'"
                  @select="onPartnerAutoCompleteSelect"
                  @open="onPartnerOpen"
                  @close="onPartnerClose"
                ></kendo-autocomplete>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-search"></i>
                  </span>
                </div>
              </div>                       
          </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label class="required-label">Tax Year</label> 
              <div id="kendo-select">
                 <kendo-dropdownlist v-model="DirectInvestmentInfo.TaxYear"
                            :data-source="TaxYearOptions"
                            :data-text-field="'Option'"
                            :option-label="'Select Tax Year'"
                            :data-value-field="'Option'">
                </kendo-dropdownlist>
              </div>
              <!-- <select v-model="DirectInvestmentInfo.TaxYear"  class="form-control">
              <option value selected>Select Tax Year</option>      
              <option
                v-for="option in TaxYearOptions"
                :key="option.Id"
                :value="option.Option"
              >{{option.Option}}</option> 
              </select>  -->
              
            </div>
			<div class="form-group col-md-6">
              <label class="required-label">Tax Quarter</label> 
              <div id="kendo-select">
              <kendo-dropdownlist v-model="DirectInvestmentInfo.TaxQuarter"
                            :data-source="TaxQuarterOptions"
                            :data-text-field="'Option'"
                            :option-label="'Select Tax Quarter'"
                            :data-value-field="'Option'">
                </kendo-dropdownlist>
              </div>
              <!-- <select v-model="DirectInvestmentInfo.TaxQuarter"  class="form-control">
              <option value selected>Select Tax Quarter</option>      
              <option
                v-for="option in TaxQuarterOptions"
                :key="option.Id"
                :value="option.Option"
              >{{option.Option}}</option> 
              </select>  -->
              
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6"> 
              <label class="required-label">Commitments Funded</label>              
              <input
                type="number"
                id="txtCommitmentsFunded"                              
                v-model="DirectInvestmentInfo.CommitmentFunded"
                class="form-control"
                placeholder="Commitments Funded"
              >                   
            </div>
            <div class="form-group col-md-6"> 
              <label class="required-label">Commitments Remaining</label>              
              <input
                type="number"
                id="txtCommitmentsRemaining"                               
                v-model="DirectInvestmentInfo.CommitmentRemaining"
                class="form-control"
                placeholder="Commitments Remaining"
              >                   
            </div>				
          </div>  

          <div class="form-row">
            <div class="form-group col-md-6"> 
              <label class="required-label">Previous Cash Distributions</label>              
              <input
                type="number"
                id="txtPriorCashDistribution"                              
                v-model="DirectInvestmentInfo.PriorCashDistribution"
                class="form-control"
                placeholder="Previous Cash Distributions"
              >                   
            </div>
            <div class="form-group col-md-6"> 
              <label class="required-label">Projected Value</label>              
              <input
                type="number"
                id="txtProjectedValue"                               
                v-model="DirectInvestmentInfo.ProjectedValue"
                class="form-control"
                placeholder="Projected Value"
              >                   
            </div>				
          </div>  

          <div class="form-row">
            <div class="form-group col-md-6"> 
             <label class="required-label">Current Value</label>              
              <input
                type="number"
                id="txtCurrentValue"                               
                v-model="DirectInvestmentInfo.CurrentValue"
                class="form-control"
                placeholder="Current Value"
              >                    
            </div>				
          </div>  
          <div class="form-row">
            <div class="form-group col-md-12">
                <label>Notes/Comments</label>		
                <textarea class="form-control" rows="4" cols="50" id="txtNote" placeholder="Notes/Comments" v-model="DirectInvestmentInfo.Note"></textarea>
            </div>
          </div>     
         

        </form>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import $ from "jquery";
import BaseModal from "@/components/base/BaseModal.vue";
import apiUtil from "@/services/apiUtil.js";
import BaseModelInputControl  from "@/models/BaseModelInputControl.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelDirectInvestmentValuation from "@/models/BaseModelDirectInvestmentValuation.js";
import moment from "moment";
import funcUtil from "@/services/funcUtil.js";
import ValuationMixin from "@/mixins/ValuationMixin.js"
import BaseGrid from "@/components/base/BaseGrid.vue";
import {mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: "DirectInvestmentForm",
  props: {
    DirectInvestmentInfo: {},
    DirectInvestmentModalLabel: {},    
    ProgramUnitClassJsonData: {}
  },
  mixins: [apiUtil, funcUtil,ValuationMixin],
  computed: {
    ...mapGetters("getModule",["withFilter","getLocalInputControls"]),
    ...mapState("postModule",["response"]),
     
  },
  data: function() {
    return {
      BaseModelDirectInvestmentValuation: BaseModelDirectInvestmentValuation,      
      BaseModelInvestment: BaseModelInvestment,
      BaseModelPartner: BaseModelPartner,      
      
      displayErrors: false,
      BaseModelInputControl: BaseModelInputControl,
      dropdowns: {
        TaxYear: { model: "", dataSource: [] }, 
        TaxQuarter: { model: "", dataSource: [] },              
      },
      customerrors:[],            
      TaxYearOptions:[],
      TaxQuarterOptions:[],
      pageErrors : [],
      InvestmentAutoCompleteSource: [],
      PartnerAutoCompleteSource: [],
      PartnerAutoCompleteDisplayedValue:"",
      InvestmentAutoCompleteDisplayedValue:"",
      bInvestmentValid:true,
      bPartnerValid:true
      // ProgramUnitClassJsonData:[],
      // programAutoCompleteDisplayedValue:"",
      // partnerAutoCompleteDisplayedValue:"",
    };
  },
  methods: {
      ...mapActions("postModule",['UpdateItems','CreateItems']),

    onInvestmentAutoCompleteSelect(e) {
      this.bInvestmentValid=true;
      this.DirectInvestmentInfo.InvestmentId = e.dataItem.Id;
      this.DirectInvestmentInfo.InvestmentTitle = e.dataItem.Title; 
      this.DirectInvestmentInfo.InvestmentInvestmentID = e.dataItem.InvestmentID; 
    },
    onInvestmentOpen(){
      this.bInvestmentValid=false;
    },
    onInvestmentClose(){
      if (!this.bInvestmentValid) {
        this.DirectInvestmentInfo.InvestmentId = null;
        this.DirectInvestmentInfo.InvestmentTitle = null; 
      }
    },
    onPartnerAutoCompleteSelect(e) { 
      this.bPartnerValid=true;   
      this.DirectInvestmentInfo.PartnerId = e.dataItem.Id;
      this.DirectInvestmentInfo.PartnerFullName = e.dataItem.FullName;
      this.DirectInvestmentInfo.PartnerPartnerID = e.dataItem.PartnerID; 
    },
    onPartnerOpen(){
      this.bPartnerValid=false;
    },
    onPartnerClose(){
      if (!this.bPartnerValid) {
        this.DirectInvestmentInfo.PartnerId = null;
        this.DirectInvestmentInfo.PartnerFullName = null; 
      }
    },
    Validate(){
            const self=this;
            self.pageErrors = [];
            let bDuplicateCheckFields = false, bDuplicateYearQuarter= false;
            let form=self.DirectInvestmentInfo;
        //Form Validation
            if (!(form.PartnerId && form.PartnerFullName)) {
                self.pageErrors.push('Partner is required');
                bDuplicateCheckFields = true;
            }
            if (!(form.InvestmentId && form.InvestmentTitle)) {
                self.pageErrors.push("Investment is required");
                bDuplicateCheckFields = true;
            }
            if (!form.TaxYear) {
                self.pageErrors.push("Tax Year is required");
                bDuplicateCheckFields = true;
            }
            if (!form.TaxQuarter) {
                self.pageErrors.push("Tax Quarter is required");
                bDuplicateCheckFields = true;
            }    
             if (!form.CommitmentFunded) {
                self.pageErrors.push('Commitments Funded is required');
            }
            if (!form.CommitmentRemaining) {
                self.pageErrors.push("Commitments Remaining is required");
            }
            if (!form.PriorCashDistribution) {
                self.pageErrors.push("Previous Cash Distributions is required");
            }
            if (!form.ProjectedValue) {
                self.pageErrors.push("Projected Value is required");
            }
            if (!form.CurrentValue) {
                self.pageErrors.push("Current Value is required");
            }  
            if (self._validateSpecialCharacter(form.Note,"multiline")) {
              self.pageErrors.push(`Note cannot have ${this.MultiLineSpecialChars}  Characters`);
            }
            
            if(self.DirectInvestmentModalLabel.modalAddorEdit == "add"){
              //checking duplicate tax year & Quarter for the investment and Partner
              if(!bDuplicateCheckFields){
                let DIList = this.withFilter(BaseModelDirectInvestmentValuation.list);
                let duplicateArray = DIList.filter(obj => {
                    return obj.PartnerId == form.PartnerId && obj.InvestmentId == form.InvestmentId && obj.TaxYear == form.TaxYear && obj.TaxQuarter == form.TaxQuarter
                });

                if(duplicateArray.length>0){
                  self.pageErrors.push("Direct Investment values already exist for the provided Tax year and quarter");
                }
              } 
            }            

        //Validation failed or success
            return self.pageErrors.length>0 ? false:true
    },
    
     getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );
      // self._getInputControls().then(response => {
        console.log(response);
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
          // self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
        });

        //Filling the Drop down options for the Grid DropDown Columns
        // this.toolbarDropDowns.TaxPeriod= this.dropdowns.TaxPeriod.dataSource;
        this.TaxYearOptions=this.dropdowns.TaxYear.dataSource;
        this.TaxQuarterOptions=this.dropdowns.TaxQuarter.dataSource; 
      // });
    },   

    saveChanges: function(e) {
      let self=this;
      this.displayErrors = true;
     
        if (self.Validate()) {
           this.DirectInvestmentInfo.CommitmentFunded = parseInt(this.DirectInvestmentInfo.CommitmentFunded);
            this.DirectInvestmentInfo.CommitmentRemaining = parseInt(this.DirectInvestmentInfo.CommitmentRemaining);
            this.DirectInvestmentInfo.PriorCashDistribution = parseInt(this.DirectInvestmentInfo.PriorCashDistribution);
            this.DirectInvestmentInfo.ProjectedValue = parseInt(this.DirectInvestmentInfo.ProjectedValue);
            this.DirectInvestmentInfo.CurrentValue = parseInt(this.DirectInvestmentInfo.CurrentValue);
            this._saveChangesValuation(this.DirectInvestmentModalLabel.modalAddorEdit,this.DirectInvestmentInfo,this.BaseModelDirectInvestmentValuation)
        }
        else{
          // $('#pageErrors').focus();
          let basemodal = $("#BaseModal");
          $("input:text:visible:first", basemodal).focus();
        }
        // });
      // }      
    },
    
     resetFields: function() {
      this._resetFieldsValuation();
    },

    getInvestmentAutoCompleteData() {    

    //   this._getItems(BaseModelInvestment).then(response => {
    //     this.InvestmentAutoCompleteSource = response;
    //   });

      this.InvestmentAutoCompleteSource = this.withFilter(BaseModelInvestment.list);

    },
    getPartnerAutoCompleteData() {
    //   this._getItems(BaseModelPartner).then(response => {
    //     this.PartnerAutoCompleteSource = response;
    //   });
    this.PartnerAutoCompleteSource = this.withFilter(BaseModelPartner.list);
    },
  },
  mounted() {
     this.getInputControls();

    // alert(JSON.stringify(this.ProgramInfoFormConfig));
    this.resetFields();
    // this.getInvestmentAutoCompleteData();
    // this.getPartnerAutoCompleteData();

    $("#BaseModal").on("shown.bs.modal", function() {
      $("input:text:visible:first", this).focus();
    });

    //For Displaying List on Focus
    this.ShowAutoCompleteListOnFocus("SearchInvestment");
    this.ShowAutoCompleteListOnFocus("SearchPartner");
    
    // $("#dtDirectInvestmentDate").on("change",this.DirectInvestmentDateChanged);
  },
  components: {
    BaseModal,    
  }
};
</script>
<style scoped>
.k-widget.k-autocomplete.k-header.k-state-default {
  width: 250px;
  background-color: yellow;
}

/* input[type="radio"]{
  width: 22px;
  margin-top: 4px;
}*/
/* .addButtonClass{
  /* margin-left:70%; 
} */
</style>
